import { Component, OnInit, inject } from '@angular/core';
import { UserService } from '../../../common/services/user.service';
import { TimeClockRecord, UserClockInResponse } from '../../../common/models/UserId';
import { finalize, take } from 'rxjs';
import { BaseComponent } from '../../../common/components/base.component';
import { SpinnerService } from '../../../common/services/spinner.service';

@Component({
    selector: 'app-user-checkin',
    templateUrl: './user-checkin.component.html',
    styleUrl: './user-checkin.component.scss',
    standalone: false
})
export class UserCheckinComponent extends BaseComponent implements OnInit {

  #userService = inject(UserService)
  #spinnerService = inject(SpinnerService)
  today = new Date();
  isCheckedIn = true;
  clockInResponse: UserClockInResponse | undefined;
  isClockInEnabled = false;
  clockInTimes: TimeClockRecord[] = [];

  ngOnInit(): void {
    this.getClockinTimes();
  }
  getClockinTimes() {
    this.#spinnerService.setLoading(true, 'user-clockinTimes');
    this.subscriptions.add(this.#userService.clockinTimes()
      .pipe(
        take(1),
        finalize(() => { this.#spinnerService.setLoading(false, 'user-clockinTimes'); }))
      .subscribe({
        next: (val) => {
          if (val) {
            this.clockInResponse = val;
            this.isClockInEnabled = this.clockInResponse.IsClockinEnabled;
            this.clockInTimes = this.clockInResponse.TimeClockRecords ?? [];
            this.isCheckedIn = (this.clockInResponse.TimeClockRecords?.length > 0 && this.clockInResponse.TimeClockRecords[this.clockInResponse.TimeClockRecords.length - 1].ClockOut == undefined);
          }
        },
        error: () => {
          this.isCheckedIn = false;
        }
      }))
  }

  onCheckinClicked() {
    if (!this.clockInResponse) return;
    if (this.isCheckedIn) {
      this.#spinnerService.setLoading(true, 'user-checkout');
      this.subscriptions.add(this.#userService.checkout()
        .pipe(
          take(1),
          finalize(() => { this.#spinnerService.setLoading(false, 'user-checkout'); }))
        .subscribe({
          next: () => {
            this.getClockinTimes();
          }
        }));
    } else {
      this.#spinnerService.setLoading(true, 'user-checkin');
      this.subscriptions.add(this.#userService.checkin(this.clockInResponse.StoreId)
        .pipe(
          take(1),
          finalize(() => { this.#spinnerService.setLoading(false, 'user-checkin'); }))
        .subscribe({
          next: () => {
            this.getClockinTimes();
          }
        }));
    }
  }

  onCancelClicked() {

  }
}
